import { useState } from "react";
import styled from "styled-components";
import { getLocale } from "react-i18nify";

// import device from "src/styles/device";
import font from "src/styles/font";

import {
  Box,
  TextField,
  Autocomplete,
  createFilterOptions,
  Stack,
  IconButton,
} from "@mui/material";

import Button from "src/components/core/Button";

import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";
import InsertPhotoIcon from "@mui/icons-material/InsertPhoto";

import { UseUpload } from "src/context/UploadProductContext";
import { convertPrice } from "src/common";

const WrapperTextfield = styled.div`
  width: 100%;
  max-width: 578px;
  padding: 0 24px;
  margin-bottom: 8px;

  .TextField-without-border-radius fieldset {
    border-radius: 24px;
    // text-align: center;
    // background: #fff;
  }
  .TextField-without-border-radius-amount fieldset {
    border-radius: 24px;
    width: 100%;
    text-align: center;
    background: #fff;
  }
  .MuiAutocomplete-root {
    margin: 0;
  }
  .MuiOutlinedInput-input {
    background: #fff;
    /* border-radius: 24px; */
    padding: 16px;
  }
  .MuiInputBase-root-MuiOutlinedInput-root {
    border-radius: 24px;
    background: #fff;
  }
  .MuiInputBase-root-MuiOutlinedInput-root-MuiSelect-root {
    border-radius: 24px;
  }

  .MuiTextField-root {
    border-radius: 24px;
  }
  .MuiOutlinedInput-root {
    border-radius: 24px;
  }
  /* .MuiAutocomplete-root .MuiOutlinedInput-root .MuiAutocomplete-input {
    padding: 7.5px 0
  } */
`;

const ImageEmpty = styled.div`
  align-items: center;
  display: flex;
  justify-content: center;
  width: 80px;
  height: 80px;
  background: #f2f1f3;
  border-radius: 16px;
  object-fit: cover;
  object-position: center;
  cursor: pointer;
  vertical-align: initial;
  margin-right: 8px;
  &:hover {
    opacity: 0.8;
  }

  &.active {
    border: 2px solid #707070;
  }
`;

const TextOption = styled(Box)`
  width: 100%;
  color: ${({ color }) =>
    color === "grey" ? "var(--darkgrey-color)" : "var(--secondary-color)"};
  font-size: ${font.size.sm};
  font-weight: 400;
  margin-bottom: 8px;
`;

const EmptySelected = styled.div`
  width: 100%;
  min-height: calc(75dvh - 62px);
  display: flex;
  align-items: center;
  justify-content: center;

  span {
    font-size: ${font.size.md};
    font-weight: 400;
    color: var(--lightgrey-color);
  }
`;

const WrapperSelected = styled.div`
  width: 100%;
  max-height: calc(75dvh - 170px);
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;

  ::-webkit-scrollbar {
    width: 7px;
    height: 5px;
  }
  /* Track */
  ::-webkit-scrollbar-track {
    background: transparent;
  }
  /* Handle */
  ::-webkit-scrollbar-thumb {
    background: var(--grey-color);
    border-radius: 100px;
  }
  /* Handle on hover */
  ::-webkit-scrollbar-thumb:hover {
    background: var(--grey-color);
  }
  ::-webkit-scrollbar-corner {
    background: transparent;
  }
`;

const SelectedGroup = styled.div`
  width: 100%;
  height: max-content;
  min-height: calc(75dvh - 170px);
  display: flex;
  flex-direction: column;
`;

const SelectedItems = styled.div`
  width: 100%;
  padding: 16px 24px;
  border-bottom: 5px solid var(--darkwhite-color);

  /* :last-child {
    border-bottom: none;
  } */
`;

const WrapperItems = styled.div`
  width: 100%;
  max-width: 615px;
  margin: 0 auto;
  display: flex;
  flex-wrap: wrap;
`;

const TextItem = styled(Box)`
  width: ${({ width, isLast }) => (width ? width : isLast ? "50%" : "100%")};
  color: ${({ color }) =>
    color === "grey" ? "var(--darkgrey-color)" : "var(--secondary-color)"};
  font-size: ${font.size.sm};
  font-weight: 400;
  margin-bottom: ${({ isLast }) => (isLast ? "0" : "8px")};
`;

const ButtonGroup = styled(Stack)`
  flex: 0 0 auto;
  width: 100%;
  /* height: max-content; */
  background-color: #fff;
  z-index: 15;
  padding: 32px 24px;
`;

const AddProduct = ({
  quoList,
  dataProductList,
  onRemoveElement,
  onSubmit,
  onClose,
}) => {
  const [selectedProduct, setSelectedProduct] = useState([]);

  const { masterdata } = UseUpload();

  const color_data = masterdata.color_data;

  const removeItem = (item) => {
    setSelectedProduct((current) =>
      current.filter((product) => product._id !== item._id)
    );
  };

  const importProduct = async () => {
    const productList = [];

    if (quoList[0]?.product_choice_id === null) {
      onRemoveElement(0);
    }

    selectedProduct.map((product) =>
      productList.push({
        product_choice_id: product,
        volume: 1,
        price: product?.group_price?.is_start_price
          ? product?.group_price?.start_price
          : product?.group_price?.special_price > 0 &&
            product?.group_price?.special_price !== null &&
            product?.group_price?.special_price !== undefined
          ? product?.group_price?.special_price
          : product?.group_price?.price,
        discount: 0,
        total: product?.group_price?.is_start_price
          ? product?.group_price?.start_price
          : product?.group_price?.special_price > 0 &&
            product?.group_price?.special_price !== null &&
            product?.group_price?.special_price !== undefined
          ? product?.group_price?.special_price
          : product?.group_price?.price,
        description: "",
      })
    );

    await onSubmit(productList);
    await onClose();
  };

  const filterOptions = createFilterOptions({
    matchFrom: "any",
    limit: 100,
  });

  return (
    <>
      <Box
        sx={{
          width: "100%",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
        }}
      >
        <WrapperTextfield>
          <Autocomplete
            aria-required={true}
            id="search-product-select"
            multiple
            isOptionEqualToValue={(option, value) => option._id === value._id}
            renderOption={(props, option) => (
              <li
                {...props}
                style={{
                  borderBottom: "4px solid var(--darkwhite-color)",
                }}
                key={`product-quotation-${option._id}`}
              >
                <Box
                  sx={{
                    width: "100%",
                    py: 2,
                    display: "flex",
                  }}
                >
                  <Box sx={{ mr: 1 }}>
                    {!!option?.group_image?.product_display_image === false ? (
                      <ImageEmpty>
                        <InsertPhotoIcon
                          sx={{
                            color: "rgba(0, 0, 0, 0.54)",
                            cursor: "pointer",
                          }}
                        />
                      </ImageEmpty>
                    ) : (
                      <img
                        style={{
                          width: "80px",
                          height: "80px",
                          objectFit: "cover",
                          objectPosition: "center",
                          borderRadius: "16px",
                          marginRight: "8px",
                        }}
                        src={
                          option?.group_image?.product_display_image
                            ? option?.group_image?.product_display_image.replace(
                                ".com",
                                ".com/300x300"
                              )
                            : ""
                        }
                        alt={option?.group_image?.product_display_image}
                      />
                    )}
                  </Box>

                  <Box
                    sx={{
                      width: "100%",
                      maxWidth: "calc(100% - 88px)",
                    }}
                  >
                    <TextOption>{option?.product?.item_name}</TextOption>

                    <TextOption color="grey">
                      {option?.product?.item_code}
                    </TextOption>

                    <Box
                      sx={{
                        width: "100%",
                        display: "flex",
                        alignItems: "center",
                        mb: 1,
                      }}
                    >
                      <img
                        style={{
                          width: "16px",
                          height: "16px",
                          objectFit: "cover",
                          objectPosition: "center",
                          borderRadius: "50%",
                        }}
                        src={
                          color_data.find(
                            (detail) => detail._id === option?.color._id
                          )?.icon_img || ""
                        }
                        alt={option?.group_image?.product_display_image}
                      />

                      <TextOption color="grey" sx={{ ml: 1, mb: 0 }}>
                        {getLocale() === "th"
                          ? option?.color?.color_th
                          : option?.color?.color_en}
                      </TextOption>
                    </Box>

                    <TextOption color="grey">
                      {option?.size?.quantity === "size"
                        ? `${option?.size?.width} ${
                            getLocale() === "th"
                              ? option?.size?.unit_width?.unit_th
                              : option?.size?.unit_width?.unit_en
                          } x ${option?.size?.height} ${
                            getLocale() === "th"
                              ? option?.size?.unit_height?.unit_th
                              : option?.size?.unit_height?.unit_en
                          } x ${option?.size?.thickness} ${
                            getLocale() === "th"
                              ? option?.size?.unit_thickness?.unit_th
                              : option?.size?.unit_thickness?.unit_en
                          }`
                        : option?.size?.quantity === "capacity"
                        ? `${option?.size?.capacity_size} ${
                            getLocale() === "th"
                              ? option?.size?.unit_capacity?.unit_th
                              : option?.size?.unit_capacity?.unit_en
                          }`
                        : getLocale() === "th"
                        ? "สินค้าสั่งทำพิเศษ"
                        : "Made by order"}
                    </TextOption>

                    <TextOption color="grey">
                      {`${convertPrice(
                        option?.group_price?.is_start_price === true
                          ? option?.group_price?.start_price
                          : option?.group_price.special_price > 0 &&
                            option?.group_price.special_price !== null &&
                            option?.group_price.special_price !== undefined
                          ? option?.group_price.special_price
                          : option?.group_price?.price
                      )}/${
                        getLocale() === "th"
                          ? option?.group_price?.unit_price?.unit_th
                          : option?.group_price?.unit_price?.unit_en
                      }`}
                    </TextOption>
                  </Box>
                </Box>
              </li>
            )}
            options={dataProductList}
            value={selectedProduct}
            onChange={(event, newValue, reason) => {
              if (reason !== "removeOption") {
                setSelectedProduct(newValue);
              }
            }}
            getOptionLabel={(option) => {
              return (
                option?.product?.item_name +
                " - " +
                option?.product?.item_code +
                (option?.name !== "" ? ` - (` + option?.name + `)` : ``)
              );
            }}
            renderTags={(value) => null}
            filterSelectedOptions
            filterOptions={filterOptions}
            sx={{
              my: 2,
              width: "100%",
              background: "#fff",
              ".MuiOutlinedInput-root": {
                paddingLeft: "16px",
              },
            }}
            renderInput={(params) => (
              <TextField
                className="TextField-without-border-radius"
                {...params}
                placeholder="เพิ่มสินค้า"
              />
            )}
          />
        </WrapperTextfield>

        {selectedProduct.length > 0 ? (
          <>
            <WrapperSelected>
              <SelectedGroup>
                {selectedProduct.map((product, index) => (
                  <SelectedItems
                    key={`product-selected-${product._id}-${index}`}
                  >
                    <WrapperItems>
                      <TextItem width="calc(100% - 30px)">
                        {product?.product?.item_name}
                      </TextItem>

                      <IconButton
                        aria-label="delete"
                        onClick={() => {
                          removeItem(product);
                        }}
                        sx={{
                          width: "30px",
                          p: "6px",
                          ":disabled": {
                            ".MuiSvgIcon-root": {
                              color: "var(--darkgrey-color)",
                            },
                          },
                        }}
                      >
                        <DeleteOutlineIcon
                          sx={{
                            color: "var(--primary-color)",
                            width: "16px",
                            height: "18px",
                          }}
                        />
                      </IconButton>

                      <TextItem color="grey">
                        {product?.product?.item_code}
                      </TextItem>

                      <Box
                        sx={{
                          width: "100%",
                          display: "flex",
                          alignItems: "center",
                          mb: 1,
                        }}
                      >
                        <img
                          style={{
                            width: "16px",
                            height: "16px",
                            objectFit: "cover",
                            objectPosition: "center",
                            borderRadius: "50%",
                          }}
                          src={
                            color_data.find(
                              (detail) => detail._id === product?.color._id
                            ).icon_img || ""
                          }
                          alt={product?.group_image?.product_display_image}
                        />

                        <TextItem color="grey" sx={{ ml: 1, mb: 0 }}>
                          {getLocale() === "th"
                            ? product?.color?.color_th
                            : product?.color?.color_en}
                        </TextItem>
                      </Box>

                      <TextItem color="grey" isLast>
                        {product?.size?.quantity === "size"
                          ? `${product?.size?.width} ${
                              getLocale() === "th"
                                ? product?.size?.unit_width?.unit_th
                                : product?.size?.unit_width?.unit_en
                            } x ${product?.size?.height} ${
                              getLocale() === "th"
                                ? product?.size?.unit_height?.unit_th
                                : product?.size?.unit_height?.unit_en
                            } x ${product?.size?.thickness} ${
                              getLocale() === "th"
                                ? product?.size?.unit_thickness?.unit_th
                                : product?.size?.unit_thickness?.unit_en
                            }`
                          : product?.size?.quantity === "capacity"
                          ? `${product?.size?.capacity_size} ${
                              getLocale() === "th"
                                ? product?.size?.unit_capacity?.unit_th
                                : product?.size?.unit_capacity?.unit_en
                            }`
                          : getLocale() === "th"
                          ? "สินค้าสั่งทำพิเศษ"
                          : "Made by order"}
                      </TextItem>

                      <TextItem sx={{ textAlign: "right" }} color="grey" isLast>
                        {`${convertPrice(
                          product?.group_price?.is_start_price === true
                            ? product?.group_price?.start_price
                            : product?.group_price.special_price > 0 &&
                              product?.group_price.special_price !== null &&
                              product?.group_price.special_price !== undefined
                            ? product?.group_price.special_price
                            : product?.group_price?.price
                        )}`}
                      </TextItem>
                    </WrapperItems>
                  </SelectedItems>
                ))}
              </SelectedGroup>
            </WrapperSelected>

            <ButtonGroup
              // flexDirection={"row"}
              justifyContent={"center"}
              alignItems={"center"}
              // columnGap={2}
            >
              <Button
                variant="contained"
                size="large"
                onClick={() => importProduct()}
                sx={{
                  width: "100%",
                  maxWidth: 350,
                  borderRadius: 4,
                  py: 1.5,
                }}
              >
                {`Import (${selectedProduct.length})`}
              </Button>
            </ButtonGroup>
          </>
        ) : (
          <EmptySelected>
            <span>ค้นหาโดย รหัสสินค้า / ชื่อสินค้า</span>
          </EmptySelected>
        )}
      </Box>
    </>
  );
};

export default AddProduct;
